console.log("[trackSampler] loaded");

let hiddenCanvas = null;
let hiddenCtx = null;
let svgElement = null;
const getSimGridSize = () => {
    try {
        const store =
            window.__REDUX_STORE__ ||
            window.reduxStore ||
            window.store ||
            window.__store;
        const state = store?.getState?.();
        const width = Math.max(1, Math.floor(state?.scene?.simGridWidth ?? 20));
        const height = Math.max(1, Math.floor(state?.scene?.simGridHeight ?? 15));
        return { width, height };
    } catch (err) {
        return { width: 20, height: 15 };
    }
};

export function initTrackSampler() {
    svgElement = document.querySelector(".simulator svg");

    if (!svgElement) {
        console.warn("[trackSampler] SVG not found, retrying...");
        setTimeout(initTrackSampler, 500);
        return;
    }

    const svgData = new XMLSerializer().serializeToString(svgElement);
    const blob = new Blob([svgData], { type: "image/svg+xml" });
    const url = URL.createObjectURL(blob);

    const img = new Image();
    img.onload = () => {
        hiddenCanvas = document.createElement("canvas");
        hiddenCanvas.width = img.width;
        hiddenCanvas.height = img.height;
        hiddenCanvas.style.display = "none";
        document.body.appendChild(hiddenCanvas);

        hiddenCtx = hiddenCanvas.getContext("2d", { willReadFrequently: true });
        hiddenCtx.drawImage(img, 0, 0);

        console.log("[trackSampler] ✔ SVG copied to offscreen canvas");
    };

    img.src = url;
}

export function getColorAtGrid(x, y) {
    if (!hiddenCtx || !hiddenCanvas) {
        console.warn("[trackSampler] Canvas not ready yet...");
        return { r: 255, g: 255, b: 255 };
    }

    const { width: GRIDW, height: GRIDH } = getSimGridSize();
    const screenX = Math.round((x / GRIDW) * hiddenCanvas.width);
    const screenY = Math.round((y / GRIDH) * hiddenCanvas.height);

    const pixel = hiddenCtx.getImageData(screenX, screenY, 1, 1).data;
    return { r: pixel[0], g: pixel[1], b: pixel[2] };
}

// Make it accessible from console
if (typeof window !== "undefined") {
    window.initTrackSampler = initTrackSampler;
    window.getColorAtGrid = getColorAtGrid;
}
 
